import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

type Tone = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

const toneClass: Record<Tone, string> = {
  neutral:
    'bg-[var(--color-surface-muted)] text-[var(--color-foreground-muted)] border-[var(--color-border)]',
  success: 'bg-[color-mix(in_oklab,var(--color-success)_15%,transparent)] text-[var(--color-success)]',
  warning: 'bg-[color-mix(in_oklab,var(--color-warning)_15%,transparent)] text-[var(--color-warning)]',
  danger: 'bg-[color-mix(in_oklab,var(--color-danger)_15%,transparent)] text-[var(--color-danger)]',
  info: 'bg-[color-mix(in_oklab,var(--color-primary)_15%,transparent)] text-[var(--color-primary)]',
};

type Props = HTMLAttributes<HTMLSpanElement> & {
  tone?: Tone;
};

export function Badge({ className, tone = 'neutral', ...rest }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-md border border-transparent px-2 py-0.5 text-xs font-medium',
        toneClass[tone],
        className,
      )}
      {...rest}
    />
  );
}
